<template>
  <v-container fluid>
    <v-row v-if="!isDone && !getPollDone"
        align="center"
        justify="center"
        no-gutters>
      <v-col cols="12" class="text-center">
        <span>{{ questionsAnswered.length }} de {{ totalQuestion }} Preguntas</span>
      </v-col>
      <v-col class="text-center row" cols="11">
        <v-col cols="8" class="pt-6">
          <v-progress-linear
              :active="active"
              :background-opacity="opacity"
              :bottom="bottom"
              :buffer-value="buffer"
              :height="height"
              :indeterminate="indeterminate"
              :query="query"
              :rounded="rounded"
              :stream="stream"
              :striped="striped"
              :top="top"
              :value="ProgressValue"
              color="accent"
          ></v-progress-linear>
        </v-col>
        <v-col class="align-center" cols="3">
          <v-btn class="text-center text-capitalize"
                 outlined
                 rounded
                 @click="donePoll"
                 :disabled="disable"
                 color="accent">
            <span v-if="!disable">Enviar</span>
            <span v-else>Procesando</span>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <div id="scroll-container-question" class="mt-3"  v-if="!isDone && !getPollDone">
      <v-row class="container-question" v-for="(item, i) in questions" :key="i+1"
             align="center"
             :class="answeredContainer(i+1)"
             no-gutters>
        <v-col cols="2">
          <button class="btn-question" :class="answeredBtn(i+1)"
          :disabled="disable">
            <v-icon v-if="answeredBtnActive(i+1)">ico-b-{{ parseInt(i) + 1 }}</v-icon>
            <v-icon v-else>ico-{{ parseInt(i) + 1 }}</v-icon>
          </button>
        </v-col>
        <v-col cols="2" v-for="(items, x) in item.alternativesNumber" :key="x">
          <button class="answer"
                  :class="answeredOption(i+1, getPosition(x)) ? 'active': 'answer'"
                  @click="e => answer(e, i+1, getPosition(x))">
            <v-icon v-if="!answeredOption(i+1, getPosition(x))" class="icon-letter">{{ getLetter(x) }}</v-icon>
            <v-icon v-else class="icon-letter">{{ getLetterActive(x) }}</v-icon>
          </button>
        </v-col>
      </v-row>
    </div>
    <RomaDonePoll v-if="isDone || getPollDone" class="done"></RomaDonePoll>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import RomaDonePoll from "@/components/poll/RomaDonePoll";

export default {
name: "RomaBarLateralPoll",
  data: () => ({
    absolute: true,
    active: true,
    opacity: 0,
    bottom: false,
    buffer: 100,
    fixed: false,
    height: 10,
    indeterminate: false,
    query: false,
    rounded: true,
    stream: false,
    striped: false,
    top: false,
    ProgressValue: 0,
    isDone: false,
    changeOption: false,
    disable: false
  }),
  components: {
    RomaDonePoll
  },
  mounted() {
    this.ProgressValue = (100 * this.questionsAnswered.length) / this.totalQuestion;
    /*
    if (this.questions.length === 0) {
      for (let index = 0; index < this.totalQuestion; index++) {
        this.questions.push(index + 1);
      }
    }
    */
  },
  computed: {
    ...mapGetters({
      totalQuestion: "getquantityQuestions",
      questionAndAnswered: "getQuestionsAndAnswered",
      questionsAnswered: "getQuestionsAnswered",
      questions: "getQuestions",
      idMedicionAsignada: "getMA",
      getPollDone: "getPollDone",
      getUserData: "getUserData",
      getPolls: "getPolls"
    })
  },
  methods: {
    ...mapActions({
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      setQuestionAndAnswered: "setQuestionAndAnswered",
      setQuestionsAnswered: "setQuestionsAnswered",
      sendPoll: "sendPoll",
      setPollDone: "setPollDone",
    }),
    async donePoll() {
      if(this.questionsAnswered.length < this.totalQuestion) {
        const reduce = this.totalQuestion - this.questionsAnswered.length;
        this.toastError({title: "Completar la encuesta", message: `Faltan ${reduce} preguntas por responder` });
      } else {
        this.disable = true;
        const answers = {
          "idMedicionAsignada": this.idMedicionAsignada,
          "answerQuestionList": this.questionAndAnswered,
          "idPersona":  this.getUserData && this.getUserData.personId ? this.getUserData.personId : null,
          // "idSeccion": this.getPolls[0] && this.getPolls[0].sectionTO.sectionId ? this.getPolls[0].sectionTO.sectionId : null,
          "idSeccionOrigen": this.getPolls[0] && this.getPolls[0].idSeccionOrigen,
          "tipoPerfil":this.getPolls[0] && this.getPolls[0].perfil,
          "userName":this.getUserData && this.getUserData.userName ? this.getUserData.userName : null
                                          
        }
        await this.sendPoll({answers: answers})
        .then(response => {
          if(response.status === 200 || response == "Encuesta ya fue enviada"){
            console.log('SetPOLLDONE')
            this.setPollDone({pollDone: true});
          }

          if(response.status === 200) {
            this.disable = false;
            this.isDone = true;
          } else {
            this.disable = false;
            if(response == "Encuesta ya fue enviada"){
              this.isDone = true;
            }else{
              this.toastError({title: "Error", message: response });
            }
          }
        })
      }

    },
    answer(e, item, option) {
      e.target.classList.toggle('active');
      const question =  this.questionAndAnswered.find(answer => answer.questionNumber === item);
      //const questionAnswered =  this.questionsAnswered.find(answer => answer === item);
      if(typeof question !== 'undefined') {
        for(const qn of this.questionAndAnswered) {
          if(qn.questionNumber === item) {
            if(qn.answerLetter === option) {
              // Remove option
              const i = this.questionAndAnswered.map(e => e.questionNumber).indexOf(item);
              this.questionAndAnswered.splice(i, 1);
              const op = this.questionsAnswered.indexOf(item);
              this.questionsAnswered.splice(op, 1 );
              if(this.changeOption) {
                // Remove and add
                this.questionsAnswered.push(item);
                this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option });
                this.changeOption = false;
              }
            } else {
              // Change
               const i = this.questionAndAnswered.map(e => e.questionNumber).indexOf(item);
               this.questionAndAnswered.splice(i, 1);
               const op = this.questionsAnswered.indexOf(item);
               this.questionsAnswered.splice(op, 1 );
               this.questionsAnswered.push(item);
               this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option }); 
               this.changeOption = true;
            }
          }
        }

      } else {
        // Add
        this.questionsAnswered.push(item);
        this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option });
      }
      this.ProgressValue = (100 * this.questionsAnswered.length) / this.totalQuestion;
      this.setQuestionsAnswered({questionsAnswered: this.questionsAnswered })
      this.setQuestionAndAnswered({questionAndAnswered: this.questionAndAnswered })
    },
    answeredContainer(id) {
      const question =  this.questionsAnswered.find(answer => answer === id);
      return [id === question ? 'answered' : ''];
    },
    answeredBtn(id) {
      const question =  this.questionsAnswered.find(answer => answer === id);
      return [id === question ? 'btn-answered' : ''];
    },
    answeredBtnActive(id) {
      const question =  this.questionsAnswered.find(answer => answer === id);
      return !!question;
    },
    answeredOption(id, option) {
      const question =  this.questionAndAnswered.find(answer => answer.answerLetter === option && answer.questionNumber === id);
      const op = typeof question !== 'undefined' ? question.answerLetter : null; 
      return option === op;
    },

    getPosition(x) {
      const array = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
      return array[x];
    },
    getLetter(x) {
      let letter = null;
      if(x === 0) {
        letter = "letter-black-a";
      }
      else if (x === 1) {
        letter = "letter-black-b";
      }
      else if (x === 2) {
        letter = "letter-black-c";
      }
      else if (x === 3) {
        letter = "letter-black-d";
      }
      else if (x === 4) {
        letter = "letter-black-e";
      }
      else if (x === 5) {
        letter = "letter-black-e";
      }
      return letter;
    },

    getLetterActive(x) {
      let letter = null;
      if(x === 0) {
        letter = "letter-white-a";
      }
      else if (x === 1) {
        letter = "letter-white-b";
      }
      else if (x === 2) {
        letter = "letter-white-c";
      }
      else if (x === 3) {
        letter = "letter-white-d";
      }
      else if (x === 4) {
        letter = "letter-white-e";
      }
      else if (x === 5) {
        letter = "letter-white-e";
      }
      return letter;
    }


  }
  
}
</script>

<style lang="scss">
  @import "../../assets/styles/numbers.css";
.done {
  height: 170vh;
}
.v-progress-linear__buffer {
  background: #d9d9d9 !important;
}
.v-application .accent {
  background-color: #e97c21 !important;
  border-color: #e97c21 !important;
  border-radius: 15px;
  z-index: 2;
}

#scroll-container-question {
  width: 100%;
  padding: 0 10px 10px 10px;
  overflow-y: scroll;
  height: 170vh;
}

#scroll-container-question {
  scrollbar-width: thin;
  scrollbar-color: blue orange;
}

#scroll-container-question::-webkit-scrollbar {
  width: 5px;
}
#scroll-container-question::-webkit-scrollbar-track {
  background: #d9d9d9;
  border-radius: 25px;
}
#scroll-container-question::-webkit-scrollbar-thumb {
  background-color: #e97c21;
  border-radius: 25px;
}

.container-question {
  background: #ffffff 0 0 no-repeat padding-box;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  opacity: 1;
  margin-bottom: 15px;
  height: auto;
}

.answered {
  border: 1px solid #3a8fce;
}

.btn-question {
  width: 45px;
  height: 44px;
  max-width: 45px;
  border-radius: 5px 0 0 5px;
  font-size: 24px;
  font-weight: bold;
  opacity: 1;
  border-right: 1px solid #d7d7d7;
  margin-right: 20px;
}

.btn-answered {
  background: #3a8fce 0 0 no-repeat padding-box;
  color: #ffffff;
}

.answer {
  width: 36px;
  height: 36px;
  background: #ffffff 0 0 no-repeat padding-box;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  opacity: 1;
  margin: 4px 0;
}

.active {
  background: #f39444 0 0 no-repeat padding-box;
  color: #ffffff;
}

.icon-letter {
  padding-bottom: 3px;
  padding-left: 1px;
}

.letter-black-a:before {
  content: url("../../assets/images/letter/black/a.svg");
}

.letter-black-b:before {
  content: url("../../assets/images/letter/black/b.svg");
}

.letter-black-c:before {
  content: url("../../assets/images/letter/black/c.svg");
}

.letter-black-d:before {
  content: url("../../assets/images/letter/black/d.svg");
}

.letter-black-e:before {
  content: url("../../assets/images/letter/black/e.svg");
}

.letter-white-a:before {
  content: url("../../assets/images/letter/a.svg");
}

.letter-white-b:before {
  content: url("../../assets/images/letter/b.svg");
}

.letter-white-c:before {
  content: url("../../assets/images/letter/c.svg");
}

.letter-white-d:before {
  content: url("../../assets/images/letter/d.svg");
}

.letter-white-e:before {
  content: url("../../assets/images/letter/e.svg");
}








</style>